import { render } from "./FpTabs.vue?vue&type=template&id=c4999d0c&lang=pug"
import script from "./FpTabs.vue?vue&type=script&lang=js"
export * from "./FpTabs.vue?vue&type=script&lang=js"

import "./FpTabs.vue?vue&type=style&index=0&id=c4999d0c&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__